// lot selectors / lots use hardcoded #enquire links but can be put on pages without the element with matching id
window.addEventListener('load', event => {
    const enquiryLinks = document.querySelectorAll('a[href="#enquire"]');
    const enquiryLinkTarget = document.getElementById('enquire');

    for ( const enquiryLink of enquiryLinks ) {
        if (!enquiryLinkTarget) {
            enquiryLink.href = '/contact-us#enquire'
        }
    }
});

